var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18V36H18C8.05888 36 0 27.9411 0 18Z",
    fill: "#FF6B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4477 9.95157C22.9164 10.4202 22.9164 11.18 22.4477 11.6486L16.0963 18.0001L22.4477 24.3516C22.9164 24.8202 22.9164 25.58 22.4477 26.0486C21.9791 26.5173 21.2193 26.5173 20.7507 26.0486L13.5507 18.8486C13.0821 18.38 13.0821 17.6202 13.5507 17.1516L20.7507 9.95157C21.2193 9.48294 21.9791 9.48294 22.4477 9.95157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.d21815a82bfa9dd4bc4fc68d758d5778.svg";
export { ForwardRef as ReactComponent };